enum OutputAttributes {
  EntryMethod = 1,
  TransactionType = 2,
  TransactionResult = 3,
  AuthorisationCode = 4,
  EMVPAN = 5,
  EMVLabel = 6,
  EMVEffectiveDate = 7,
  TransactionDate = 8,
  TransactionTime = 9,
  EMVCardHolderName = 10,
  EMVCardHolderNameExt = 11,
  MerchantIdentifier = 12,
  TerminalIdentifier = 13,
  CardVerificationMethod = 14,
  StartDate = 15,
  TotalSaleCounts = 16,
  TotalRefundCounts = 17,
  TotalSaleAmount = 18,
  TotalRefundAmount = 19,
  EFTSequenceNumber = 21,
  MerchantAddress = 22,
  MerchantName = 23,
  BatchNumber = 25,
  ReferralTel1 = 26,
  ReferralTel2 = 27,
  PGTR = 28,
  EMVAID = 29,
  PANSequenceNumber = 30,
  TransactionStatusInfo = 31,
  TerminalVerificationResults = 32,
  RetentionReminder = 33,
  CustomerDeclaration = 34,
  AdditionalResponseData = 35,
  ReceiptNumber = 36,
  CardExpiryDate = 37,
  TotalAmount = 38,
  CashBackAmount = 39,
  GratutityAmount = 40,
  FuelCardType = 41,
  Track2Data = 46,
  LegacyPAN = 59,
  CardIssuerCode = 60,
  TokenReference = 61,
  CardIdentificationWithInd = 64,
  AquirerName = 65,
  ConvertedCurrencyName = 70,
  AmountConverted = 71,
  CurrencyConversionRate = 72,
  GiftCardBalanceAmount = 73,
  PenniesDonationAmount = 74,
  TotalOfflineStoredTransactions = 75,
  PinpadSerialNumber = 76,
  AvailableOfflineSpendingAmount = 77,
  FlexecashAvailableBalanceAmount = 78,
  RetrievalReferenceNumber = 80,
  CardCountryCode = 81,
  CardCurrencyCode = 82,
  TransactionReference = 98
}

export default OutputAttributes;
